/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react';
import { getAppEnv } from '../../config/env';
import { Context } from '../../src/AppContext';

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;
type ReturnBusSectionProps = {
  sourceCityName: string;
  destinationCityName: string;
  categoryName?: string;
  url: string;
  type: string;
};

const ReturnBusSection = ({
  sourceCityName,
  destinationCityName,
  categoryName = '',
  url,
  type
}: ReturnBusSectionProps) => {
  const { trackTemplateEvent } = useContext(Context);
  return (
    <a
      href={url}
      onClick={() => {
        trackTemplateEvent(`Bus_SEO_${type}_ReturnRoute_Click`);
      }}
      className="viewAlso makeFlex column blackText visibilityAuto"
    >
      <div className="makeFlex">
        <div className="desktopShow">
          <p className=" font16 lineHeight24 latoRegular ">{`View Also`}</p>
          <p className="font20 lineHeight24 latoBlack appendRight25">
            {`${categoryName +
              ' '}Buses from ${destinationCityName} to ${sourceCityName}`}
          </p>
        </div>
        <div className="mobileShow">
          <p className=" font14 lineHeight18 latoRegular ">{`View Also`}</p>
          <p className="font14 lineHeight20 latoBlack appendRight25">
            {`${categoryName +
              ' '}Buses from ${destinationCityName} to ${sourceCityName}`}
          </p>
        </div>
        <div className="arrowContainer">
          <img
            className="lazyload"
            data-src={`${PUBLIC_URL}/static/public/ic_incard_longarrow_blue.png`}
            alt={'return route arrow'}
          />
        </div>
      </div>
    </a>
  );
};
export default ReturnBusSection;
